import { SchemaTeamChatUserStatusV1Service } from './service';
import { QueryEndpointName } from './types';

export const STANDARD_QUERY_ENDPOINT_NAMES = [
  'GetUserMessageDetails',
] as const satisfies (keyof typeof SchemaTeamChatUserStatusV1Service)[];
export const INFINITE_QUERY_ENDPOINT_NAMES = [] as const satisfies (keyof Omit<
  typeof SchemaTeamChatUserStatusV1Service,
  (typeof STANDARD_QUERY_ENDPOINT_NAMES)[number]
>)[];
export const QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_ENDPOINT_NAMES, ...INFINITE_QUERY_ENDPOINT_NAMES] as const;

export const MUTATION_ENDPOINT_NAMES = [] as const satisfies (keyof Omit<
  typeof SchemaTeamChatUserStatusV1Service,
  QueryEndpointName
>)[];

export const USER_MESSAGE_ENDPOINT = 'GetUserMessageDetails';
